import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { ListOcupaciones } from "../../../components/Admin/Ocupaciones";
import { useLanguage } from "../../../contexts";
import "./Ocupaciones.scss";

export function Ocupaciones() {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const [reload, setReload] = useState(false);
  const onReload = () => setReload((prev) => !prev);

  const panes = [
    {
      menuItem: t("active_occupations"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListOcupaciones active={true} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("inactive_occupations"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListOcupaciones active={false} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div className="ocupaciones-page" style={{ padding: "0 0 1.5rem" }}>
      <div className="ocupaciones-page-header-wrapper">
        <div className="ocupaciones-page-header">
          <span className="ocupaciones-page-title">{t("occupations")}</span>
        </div>
      </div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
}
